import { Box, Paper } from '@mui/material';
import { InlineLoader } from '../../../common/components/InlineLoader';

export const CardLoader = () => {
  return (
    <Box component={Paper} sx={{ width: 1, py: 4 }} data-role="card-loader">
      <InlineLoader size={40} color="primary.main" />
    </Box>
  );
};
